// src/index.js
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import store from './store';
import App from './App';

// Suppress ResizeObserver loop error (harmless)
const originalError = console.error;
console.error = (...args) => {
  if (args[0]?.message?.includes('ResizeObserver loop completed with undelivered notifications')) {
    return;
  }
  originalError(...args);
};

// Also catch the global error event (optional)
window.addEventListener('error', (e) => {
  if (e.message === 'ResizeObserver loop completed with undelivered notifications.') {
    e.stopImmediatePropagation();
    return false;
  }
});

ReactDOM.render(
  <Provider store={store}>
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </Provider>,
  document.getElementById('root')
);